var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"fixed inset-y-0 right-0 flex flex-shrink-0 w-full duration-300 transition-spacing lg:relative",attrs:{"is-open":_vm.isOpen}},[_c('div',{staticClass:"fixed inset-y-0 overflow-x-hidden bg-gray-100 dark:bg-gray-800 rounded-t-lg"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }